import React from 'react';
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import ReverseImg from "../../../images/itemImg/reverse.png"


const ReverseSlide = () => {
  const WarpImgStyle = css`
    width: 25vw;
    box-shadow: 5px 5px 20px 5px #123456;
    border-radius:25px;
  `;


  return (
    <div>
      <img src={ReverseImg} css={WarpImgStyle}></img>
        <p>
          リバース <br/><br/>
          進行方向が逆になります。<br/>
          消費MP20はです。<br/>
          Easyの難易度で15ポイントゲットするとこのアイテムが入手可能です。
        </p>
    </div>
  )
}

export default ReverseSlide